import React from 'react';
import { defaultLoginStore, LoginStoreProvider } from './index/pages/login/login_store';
import { defaultMainStore, MainStoreProvider } from './index/pages/main/main_store';
import { defaultScheduleStore, ScheduleStoreProvider } from './index/pages/schedule/schedule_store';
import { defaultTaskListStore, TaskListProvider } from './index/pages/task_list/tasklist_store';
import {
  defaultTaskDetailStore,
  TaskDetailProvider,
} from './index/components/task_detail/details_store';
import { defaultIssueStore, IssueProvider } from './index/pages/issue/issue_store';
import { defaultNotificationStore, NotificationProvider } from './index/pages/notification/notification_store';
import { defaultTaskCsvStore, TaskCsvProvider } from './index/pages/task_csvregist/task_csv_store';
import { defaultTaskEditStore, TaskEditProvider } from './index/pages/task_edit/task_edit_store';
import { defaultSpreadSheetStore, SpreadSheetProvider } from './lib/spreadsheet/spreadsheet_store';
import { defaultAccountListStore, AccountListProvider } from './index/pages/account_list/account_list_store';
import { defaultAccountRegisterStore, AccountRegisterProvider } from './index/pages/account_register/account_register_store';

/**
 * rootプロバイダ
 * @param children
 * @constructor
 */
export const IndexProvider : React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>
      <LoginStoreProvider storeCreator={defaultLoginStore}> 
        <MainStoreProvider storeCreator={defaultMainStore}>
          <ScheduleStoreProvider storeCreator={defaultScheduleStore}>
            <TaskListProvider storeCreator={defaultTaskListStore}>
            <TaskDetailProvider storeCreator={defaultTaskDetailStore}>
              <IssueProvider storeCreator={defaultIssueStore}>
                <NotificationProvider storeCreator={defaultNotificationStore}>
                  <TaskCsvProvider storeCreator={defaultTaskCsvStore}>
                    <TaskEditProvider storeCreator={defaultTaskEditStore}>
                      <SpreadSheetProvider storeCreator={defaultSpreadSheetStore}>
                        <AccountListProvider storeCreator={defaultAccountListStore}>
                          <AccountRegisterProvider storeCreator={defaultAccountRegisterStore}>
                          {children}
                          </AccountRegisterProvider>
                        </AccountListProvider>
                      </SpreadSheetProvider>
                    </TaskEditProvider>
                  </TaskCsvProvider>
                </NotificationProvider>
              </IssueProvider>
            </TaskDetailProvider>
            </TaskListProvider>
          </ScheduleStoreProvider>
        </MainStoreProvider>
      </LoginStoreProvider>
  </>;
};
